import Layout from '@/components/layout/index.vue'

export default {
  path: 'manage',
  name: 'Manage',
  meta: {},
  component: Layout,
  redirect: { name: 'Manage.Parasettings' },
  children: [{
    path: 'parasettings',
    name: 'Manage.Parasettings',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/parasettings/index.ts')
  },
  {
    path: 'parasettings/add',
    name: 'Manage.Parasettings.Add',
    meta: { title: 'common.add', dep: 'Manage.Parasettings' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/parasettings/add.ts')
  },
  {
    path: 'parasettings/modify/:id',
    name: 'Manage.Parasettings.Modify',
    meta: { title: 'common.modify', dep: 'Manage.Parasettings' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/parasettings/modify.ts')
  },
  {
    path: 'srmsupplierprotocol',
    name: 'Manage.Srmsupplierprotocol',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/srmsupplierprotocol/index.ts')
  },
  {
    path: 'srmsupplierprotocol/modify/:id',
    name: 'Manage.Srmsupplierprotocol.Modify',
    meta: { title: 'common.modify', dep: 'Manage.Srmsupplierprotocol' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/srmsupplierprotocol/modify.ts')
  },
  {
    path: 'docrule',
    name: 'Manage.Docrule',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/docrule/index.ts')
  },
  {
    path: 'docrule/add',
    name: 'Manage.Docrule.Add',
    meta: { title: 'common.add', dep: 'Manage.Docrule' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/docrule/add.ts')
  },
  {
    path: 'docrule/modify/:id',
    name: 'Manage.Docrule.Modify',
    meta: { title: 'common.modify', dep: 'Manage.Docrule' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/docrule/modify.ts')
  },
  {
    path: 'template-upload',
    name: 'Manage.TemplateUpload',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template-upload/index.ts')
  },
  {
    path: 'template-upload/add',
    name: 'Manage.TemplateUpload.Add',
    meta: { title: 'common.add', dep: 'Manage.TemplateUpload' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template-upload/add.ts')
  },
  {
    path: 'template-upload/modify/:id',
    name: 'Manage.TemplateUpload.Modify',
    meta: { title: 'common.modify', dep: 'Manage.TemplateUpload' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template-upload/modify.ts')
  },
  {
    path: 'quartz',
    name: 'Manage.Quartz',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/quartz/index.ts')
  },
  {
    path: 'quartz/add',
    name: 'Manage.Quartz.Add',
    meta: { title: 'common.add', dep: 'Manage.Quartz' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/quartz/add.ts')
  },
  {
    path: 'quartz/modify/:id',
    name: 'Manage.Quartz.Modify',
    meta: { title: 'common.modify', dep: 'Manage.Quartz' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/quartz/modify.ts')
  },
  {
    path: 'commit',
    name: 'Manage.Commit',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/commit/index.ts')
  },
  {
    path: 'template-manage',
    name: 'Manage.TemplateManage',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template-manage/index.ts')
  },
  {
    path: 'template-manage/add',
    name: 'Manage.TemplateManage.Add',
    meta: { title: 'common.add', dep: 'Manage.TemplateManage' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template-manage/add.ts')
  },
  {
    path: 'template-manage/modify/:id',
    name: 'Manage.TemplateManage.Modify',
    meta: { title: 'common.modify', dep: 'Manage.TemplateManage' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template-manage/modify.ts')
  },
  {
    path: 'template',
    name: 'Manage.Template',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template/index.ts')
  },
  {
    path: 'relation',
    name: 'Manage.Template.Relation',
    meta: { title: 'manage.template.maintain', dep: 'Manage.Template' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/template/relation.ts')
  },
  {
    path: 'purpurchaseunit/purchaseunit',
    name: 'Manage.Purpurchaseunit.Purchaseunit',
    meta: { title: 'manage.purpurchaseunit.purchaseunit', dep: 'Manage.Purpurchaseunit.Purchaseunit' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/purpurchaseunit/purchaseunit/index.ts')
  },
  {
    path: 'purpurchaseunit/purchaseunit/add',
    name: 'Manage.Purpurchaseunit.Purchaseunit.Add',
    meta: { title: 'common.add', dep: 'Manage.Purpurchaseunit.Purchaseunit' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/purpurchaseunit/purchaseunit/add.ts')
  },
  {
    path: 'purpurchaseunit/purchaseunit/modify/:id',
    name: 'Manage.Purpurchaseunit.Purchaseunit.Modify',
    meta: { title: 'common.modify', dep: 'Manage.Purpurchaseunit.Purchaseunit' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/purpurchaseunit/purchaseunit/modify.ts')
  },
  {
    path: 'custom-management',
    name: 'Manage.CustomManagement',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/custom-management/index.ts')
  },
  {
    path: 'custom-management/add',
    name: 'Manage.CustomManagement.Add',
    meta: { title: 'common.add', dep: 'Manage.CustomManagement' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/custom-management/add.ts')
  },
  {
    path: 'custom-management/modify/:id',
    name: 'Manage.CustomManagement.Modify',
    meta: { title: 'common.modify', dep: 'Manage.CustomManagement' },
    component: () =>
                import(/* webpackChunkName: "manage" */ '@/views/setting/manage/custom-management/modify.ts')
  }
  ]
}
